// extracted by mini-css-extract-plugin
export var box = "_42-1";
export var checkboxRow = "_42-8";
export var checked = "_42-2";
export var descriptionSpacer = "_42-a";
export var disabled = "_42-3";
export var icon = "_42-6";
export var input = "_42-0";
export var labelSpacer = "_42-9";
export var medium = "_42-5";
export var small = "_42-4";
export var text = "_42-7";